import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=687a2bfe&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687a2bfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('687a2bfe')) {
      api.createRecord('687a2bfe', component.options)
    } else {
      api.reload('687a2bfe', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=687a2bfe&scoped=true&", function () {
      api.rerender('687a2bfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28PNoMckAly2U/JS/comp/Voucher-Unit.vue"
export default component.exports